<template>
  <section class="page">
    <header-prismic/>
    <prismic-edit-button :documentId="documentId"/>
    <contact-map v-if="this.uid == 'contact'" />
    <slices-block :slices="slices" :uid="uid"/>
    <services v-if="this.uid == 'services'" />
    <above-footer/>
  </section>
</template>

<script>
// imports for all components
import HeaderPrismic from '../components/HeaderPrismic.vue'
import AboveFooter from '../components/AboveFooter.vue'
import SlicesBlock from '../components/SlicesBlock.vue'
import Services from '../components/Services.vue'
import AboutGraphic from '../components/AboutGraphic.vue'
import ContactMap from '../components/ContactMap.vue'

export default {
  name: 'page',
  components: {
    HeaderPrismic,
    AboveFooter,
    SlicesBlock,
    Services,
    AboutGraphic,
    ContactMap
  },
  data () {
    return {
      documentId: '',
      uid: '',
      fields: {
        title: null,
        tagline: null,
        image: null,
        button_link: null,
        button_label: null
      },
      slices: []
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getByUID('page', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id;
            this.uid = uid;
            this.slices = document.data.body
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    },
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid);
    next();
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/colors.scss";

.page {
  &:before {
    content: '';
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-repeat: no-repeat;
    opacity: .1;
    // background-image: url('~@/assets/img/svg-7.svg');
    background-size: cover;
  }
}

.homepage {
  .hero {
    &.jumbotron {
      width: 100%;
      background-position: 50% 100%;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      
      &:before {
        content: '';
        position: absolute;
        background: $white;
        opacity: 0.7;
        width: 100%;
        height: 100%;
      }
    }
  }
}

// .homepage-banner {
//   margin: -70px 0 80px;
//   padding: 10em 0 8em;
//   background-position: center center;
//   background-size: cover;
//   color: #ffffff;
//   line-height: 1.75;
//   text-align: center;
// }
// .banner-content {
//   text-align: center;
// }
// .banner-title,
// .banner-description {
//   width: 90%;
//   max-width: 490px;
//   margin-left: auto;
//   margin-right: auto;
// }
// .banner-title {
//   color: #ffffff;
//   font-size: 70px;
//   font-weight: 900;
//   line-height: 70px;
// }
// .banner-button {
//   background: #ffffff;
//   border-radius: 7px;
//   color: #484D52;
//   font-size: 14px;
//   font-weight: 700;
//   padding: 15px 40px;
// }
// .banner-button:hover {
//   background: #c8c9cb;
// }
/* Media Queries */
// @media (max-width: 767px) {
//   .homepage-banner {
//     margin: 0 0 40px;
//     padding: 10em 0 6em;
//   }
//   .banner-title {
//     font-size: 50px;
//     line-height: 50px;
//   }
//   .text-section-2col {
//     -webkit-column-count: 1; /* Chrome, Safari, Opera */
//     -moz-column-count: 1; /* Firefox */
//     column-count: 1;
//     -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
//     -moz-column-gap: 40px; /* Firefox */
//     column-gap: 40px;
//   }
//   .quote {
//     font-size: 20px;
//   }
//   .gallery-item {
//     -webkit-box-flex: 100%;
//     -moz-box-flex:  100%;
//     -webkit-flex:  100%;
//     -ms-flex:  100%;
//     flex: 100%;
//   }
//   .highlight-left,
//   .highlight-right {
//     width: 100%;
//     float: none;
//   }
// }

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
